module.exports = __webpack_public_path__ + "img/blog-details-2.f9a7c41b.jpg";